/**
 * Table of UUIDs used across the application
 * This table helps track and document the purpose of various UUIDs used in the system
 */

export const UUIDs = {
    // Form IDs
    forms: {
        oxfordKnee: "e2f876c1-4b4c-4a9e-a338-b6d7b9eb1e1f",
        oxfordHip: "6e079564-1c78-46ed-91af-327121aa83d9",
        oxfordShoulder: "1895bc09-2075-4bdf-9114-dd39b161fa3f",
        womac: "28e49946-4c5e-4bf0-b6ea-7b73803b3e27",
        eq5d5l: "c6b5cdc2-d3d8-44a8-8bd5-3db2696464bf",
        moxfq: "131c8bad-8458-438d-8017-5e03a373e5eb",
        heelpain: "c5e6069b-0d00-49a8-aa88-28428023faa2",
        faam: "f3c5e7b2-9a8d-4e7c-a1d6-6f3b9c8d7e9a",
        faos: "1a2b3c4d-5e6f-7a8b-9c0d-1e2f3a4b5c6d",
        cait: "bd9aff01-4d13-438e-ab3e-8b4406d76a71",
        catProm5: "ae76bcd4-2413-4ab5-89a8-e036806a3e77",
        psfs: "ecbc2751-467a-49fb-abc6-589743a842c0",
        koos: "7a8b9c0d-1e2f-3a4b-5c6d-7e8f9a0b1c2d",
        koos12: "d0fb728b-8521-47e9-8f5d-ddb4b1d49d27",
        hoos12: "7549204c-e1a9-4983-9e24-8a57569995b3",
        quickdash: "e5f8c9d2-7a3b-4e6f-9d1c-2b4a5c8e7f90",
        oswestry: "8f7d6e5c-4b3a-2918-7c6b-5a4f3e2d1c0b",
        phq9: "43aad844-b3d8-4d4d-ada7-47115f0f3361",
        rolandMorris: "6f12abc6-349a-445a-b56e-567cf4ba6b29",
        pdq: "7f3a8b2c-9d4e-4f5a-8b1c-2d3e4f5a6b7c",
        iief6: "cbceb6e3-9f70-4e55-a746-8c5f168eb88f",
        sqolM: "727bb007-400c-4388-8ac4-5788114634b2",
        pgiI: "fa3393d8-c2de-4855-a7e5-7cb3292b3d6a",
        overallTreatmentSatisfaction: "cd0d9e2b-9dee-4ce5-9de2-a5b1040bd89d",
        furtherTreatmentSinceCheckin: "3935a6b5-ab55-4c57-8fae-92ede63855ce",
        ihot12: "839771cd-f2b4-4021-9ec4-1e38c1fb8ed5",
        bctq: "5cd13eba-eeeb-4907-9949-2b1942f3ea0a",
        aofas: "8e94ac5c-19fc-4ed0-b4e2-0175e2c1fb86",
        atrs: "8b950a39-732c-4b0f-96b1-9ee5f1c86975",
        kujala: "21b77136-2b8f-4373-b223-4e5c81a46533",
        visaASedentary: "1026d5b0-60f7-4255-8bc9-163d4897e146",
        fas: "85cce0d3-84aa-483f-b238-b7a7672e327d",
        gad7: "1a6b2761-06e1-47f2-8526-56d0b90cb8d7",
        avvq: "2d25fe9e-924f-4ca1-ab9d-13451e7cd52d",
        ikdcSubjectiveKnee: "6996490a-9492-4efa-8a7f-0b45cc591683",
        kellgrenLawrence: "ae7575c2-a271-4f66-953c-43c71797ae81",
        msis29: "7b6653a6-a687-440d-935a-6a42ee94ad7c",
        symptomNrs: "7c167e60-4cdb-467f-8d49-9ef2a09f78df",
        afeqt: "c8576e61-f9f9-4238-9200-3ee15331311e",
        asta: "62cd9ca9-32ac-4806-9287-1f01314c2dd8",
        tegnerActivityScale: "6136ae73-d1c1-47e4-bdc4-73f0c9912120",
        marxActivityRatingScale: "3a5db92a-6f19-4796-b0bb-c4272f06c43e",
        aclRsi: "af6fc461-3ae7-4981-82f8-d0e82d929f15",
        bmi: "6f0e43be-8c72-4d9a-93e5-2d5cbe2a4001",
        dmHeightWeight: "0d300000-0000-4000-8000-000000000001",
    },

    // Pain Score Form IDs
    painScores: {
        painScore1: "20c05eda-61ba-4531-b3ca-5811ea7c6970",
        painScore2: "289abef6-3ce8-4b5b-b621-d622b5efc975",
        painScore3: "333d9f81-c0f8-4b28-a795-804bbdc0af78",
        painScore4: "404d9f81-c0f8-4b28-a795-804bbdc0af78",
        painScore5: "ad5ae755-bfaf-4797-bf10-71d61a5c7465",
        painScore6: "b1c23d4e-5f6a-7b8c-9d0e-1f2a3b4c5d6e", // Back and Leg Pain
        painScore7: "e4f56a7b-8c9d-0e1f-2a3b-4c5d6e7f8a9b", // Neck and Arm Pain
    },

    // Back and Leg Pain Input IDs
    backAndLegPainInputs: {
        backPainLevel: "aec82a38-fcdd-43c6-aa5c-58f5c1f56dd0",
        legPainLevel: "a6b78c9d-0e1f-2a3b-4c5d-6e7f8a9b0c1d",
    },

    // MOxFQ Page IDs
    moxfqPages: {
        painMobility: "20f741a4-b4b0-4960-b00e-0ce7b8dc6a69",
        dailyActivities: "30f741a4-b4b0-4960-b00e-0ce7b8dc6a70",
        painCharacteristics: "40f741a4-b4b0-4960-b00e-0ce7b8dc6a71",
        painAssessment: "50f741a4-b4b0-4960-b00e-0ce7b8dc6a72",
    },

    // MOxFQ Score Input IDs
    moxfqScores: {
        walkingStanding: "70f741a4-b4b0-4960-b00e-0ce7b8dc6a91",
        pain: "70f741a4-b4b0-4960-b00e-0ce7b8dc6a92",
        socialInteraction: "70f741a4-b4b0-4960-b00e-0ce7b8dc6a93",
        total: "70f741a4-b4b0-4960-b00e-0ce7b8dc6a94",
    },

    // Form Total Score IDs
    womacInputs: {
        // WOMAC Total Scores
        womacPain: "6b213817-9f43-4f97-a4a2-4c9224cd9a64",
        womacStiffness: "7386bddb-4ae3-46b1-bbdf-a1c416f3fa2e",
        womacFunction: "b63ede98-1a9a-4edd-9320-bea4441509fd",
        womacTotal: "2f7ac607-f650-4f50-9397-583725f98d0c",
    },
    oxfordKneeInputs: {
        // Oxford Knee Total Scores
        oxfordKneeTotal: "2ac66c73-1245-4540-a3c0-dfbe1f8783f2",
        oxfordKneeFunction: "11dec58c-7ce7-456a-a997-d2cf410ca37f",
        oxfordKneePain: "39029fed-98e8-45a9-867e-37dcd6de8108",
    },
    oxfordHipInputs: {
        // Oxford Hip Total Scores
        oxfordHipTotal: "530b6a68-8b26-4ca6-91aa-aa27bbcae556",
        oxfordHipFunction: "ccc0503c-96f6-4c8d-bb30-3d7e29426ac6",
        oxfordHipPain: "2a869cb9-2ef8-4ba8-8a42-52203f4c6125",
    },
    oxfordShoulderInputs: {
        oxfordShoulderTotal: "24f170af-99ee-4a7a-aba0-4c983bad82a0",
        oxfordShoulderFunction: "77dc36fe-8b63-4562-bd9f-1cd7475239c2",
        oxfordShoulderPain: "14216cc8-7562-47a5-94d5-22fd33093943",
    },
    eq5dInputs: {
        // EQ-5D Total Score
        eq5dTotal: "68f17a5e-7e1b-4afe-a7f1-078d101c07a1",
    },
    heelpainInputs: {
        exerciseAdherence: "ac3457bd-6aad-449e-9c31-0f2eac03e9d7",
        habitChangeAdherence: "b0e8f5e1-b1a4-4ed8-b2a3-31f7d640c3e7",
        nutritionAdherence: "c9f32e4a-86d5-458e-8c79-1f2b3a4c5d6e",
        comments: "42878920-51a2-4960-9d98-522bee17ef44",
        // Calculated 0-100 score derived from single-choice compliance response
        complianceScore: "f1e2d3c4-b5a6-4978-8cde-9fab01234567",
    },
    faamInputs: {
        // Calculated Scores
        adlSubscale: "d70adf4a-189f-4eec-aea4-5a4f09a57dc2",
        sportsSubscale: "7b0f6529-1162-4b05-9dad-ea70350b8d98",
        totalScore: "1f96d131-c530-4567-8e79-e6a1b8c0f33e",
        // Important Questions
        adlRating: "d2e3f4a5-b6c7-4d8e-9f0a-1b2c3d4e5f6a",
        sportsRating: "a1b2c3d4-e5f6-4a7b-8c9d-0e1f2a3b4c5e",
        function: "b2c3d4e5-f6a7-4b8c-9d0e-1f2a3b4c5d6f",
    },
    caitInputs: {
        // CAIT Total Score
        totalScore: "7d82cb99-426b-4b84-b014-3981a67f0f9f",
    },
    atrsInputs: {
        totalScore: "74056992-1e44-4cee-bd54-a5ebfe97c512",
    },
    tegnerActivityScaleInputs: {
        activityLevel: "3dd4ad16-6dc8-449d-9622-888921f41ae3",
        totalScore: "7f65e227-4a2b-4c1d-a219-de0e9a5133f8",
    },
    marxActivityRatingScaleInputs: {
        running: "e62fddfa-fed0-4e0c-b06b-8ddec70801de",
        cutting: "3f64b1a4-2dae-4e13-b150-ed43c96569d4",
        decelerating: "484064dd-7f8f-4df1-8413-9c00ea0e3188",
        pivoting: "060d06fd-0f7b-4f2f-b5a6-8ea4e38a9546",
        totalScore: "d41a22d2-1abd-4584-acaa-3a7f478a03fc",
    },
    aclRsiInputs: {
        totalScore: "2b8b8a69-1f84-4d9f-b8c5-e461340b0661",
    },
    bmiInputs: {
        bmi: "6f0e43be-8c72-4d9a-93e5-2d5cbe2a4005",
    },
    catProm5Inputs: {
        summaryScore: "0ae95f3c-c37c-495a-ab54-a25b1ff470c8",
    },
    psfsInputs: {
        ratingsList: "b1618fee-5f50-4294-909c-11a85746e9cd",
        // PSFS Average Score
        averageScore: "c7d8e9f0-a1b2-3456-cdef-789012345678",
    },
    koosPages: {
        symptoms: "c8a11111-0000-4000-8000-000000000002",
        pain: "c8a11111-0000-4000-8000-00000000000b",
        functionDailyLiving: "c8a11111-0000-4000-8000-000000000016",
        functionSportsRecreation: "c8a11111-0000-4000-8000-00000000002a",
        qualityOfLife: "c8a11111-0000-4000-8000-000000000030",
    },
    koosInputs: {
        // KOOS Calculated Scores
        painScore: "d0e1f2a3-b4c5-6d7e-8f9a-0b1c2d3e4f5a",
        symptomsScore: "e1f2a3b4-c5d6-7e8f-9a0b-1c2d3e4f5a6b",
        adlScore: "f2a3b4c5-d6e7-8f9a-0b1c-2d3e4f5a6b7c",
        sportRecreationScore: "a3b4c5d6-e7f8-9a0b-1c2d-3e4f5a6b7c8d",
        qualityOfLifeScore: "b4c5d6e7-f8a9-0b1c-2d3e-4f5a6b7c8d9e",
    },
    koos12Pages: {
        pain: "0b859896-4d6c-49b7-9774-fc6d4736d9d1",
        functionDailyLiving: "01e86117-aa0b-4abe-a8c3-467254e47de7",
        qualityOfLife: "a05bb91d-9efe-4fa3-8b64-7030e0dbfa3f",
    },
    koos12Inputs: {
        // KOOS-12 Calculated Scores
        painScore: "67f335c1-9cec-400f-94c4-eae6dc9cf10c",
        functionScore: "30b911b4-0919-4b37-9ce6-6c178488350b",
        qualityOfLifeScore: "857e0bd8-6688-4203-8ad8-6289097709b7",
        summaryScore: "0f4cad5b-a15a-44d8-b0be-13e2fd44436d",
    },
    hoos12Pages: {
        pain: "03f20b85-47cb-45f6-b117-5153203132ec",
        functionDailyLiving: "bc3db9a8-7980-4a38-b3b4-a8380e0fce88",
        qualityOfLife: "1ef0daf0-def0-4b85-940b-2f17a01d5b8e",
    },
    hoos12Inputs: {
        // HOOS-12 Calculated Scores
        painScore: "6c22b7f2-93e5-49b1-b5ca-00a735c58307",
        functionScore: "442a231b-7797-4c03-bcd0-cf8cd4d45440",
        qualityOfLifeScore: "7046fefd-df0d-4220-b8fb-e82ab1b32465",
        summaryScore: "e2cf07c8-edf0-4ccb-9738-5a7d0ca2b41a",
    },
    quickdashInputs: {
        // QuickDASH Calculated Scores
        mainScore: "f4a5b6c7-d8e9-0123-fabc-456789012345",
        workModule: "a5b6c7d8-e9f0-1234-abcd-567890123456",
        sportsModule: "b6c7d8e9-f0a1-2345-bcde-678901234567",
    },
    faosInputs: {
        // FAOS Subscale Scores
        painScore: "9a0b1c2d-3e4f-5a6b-7c8d-9e0f1a2b3c4e",
        symptomsScore: "0b1c2d3e-4f5a-6b7c-8d9e-0f1a2b3c4d5f",
        adlScore: "1c2d3e4f-5a6b-7c8d-9e0f-1a2b3c4d5e6a",
        sportRecreationScore: "2d3e4f5a-6b7c-8d9e-0f1a-2b3c4d5e6f7b",
        qualityOfLifeScore: "3e4f5a6b-7c8d-9e0f-1a2b-3c4d5e6f7a8c",
    },
    oswestryInputs: {
        // Oswestry Disability Index Scores
        rawScore: "a9b8c7d6-e5f4-3a2b-1c0d-9e8f7a6b5c4d",
        percentageScore: "b8c7d6e5-f4a3-2b1c-0d9e-8f7a6b5c4d3e",
        sectionsCompleted: "c7d6e5f4-a3b2-1c0d-9e8f-7a6b5c4d3e2f",
    },
    msis29Pages: {
        q1: "4b9ab53b-45a7-45f0-9f89-5e5b812d41f3",
        q2: "1edc411d-c615-4dcb-a3c7-d5829e3c7057",
        q3: "ed5b6c42-a809-4a82-ac89-40c3413e92c7",
        q4: "17d37d77-32aa-4fa7-8c31-d128ec8da567",
        q5: "8a7e29b0-366d-4199-86d4-cdef2a575393",
        q6: "c601d3be-06f4-423d-b469-b6320d87ceff",
        q7: "e8a55265-4bbe-4b17-8ca6-9ff0617e576a",
        q8: "6dc2305b-bcb1-4809-9cee-b1af023cc755",
        q9: "09564477-735d-471c-8baa-e78faf75a682",
        q10: "05e4342b-a1d8-4c9a-9719-ad3e27de0c52",
        q11: "45578a24-16a1-42ef-8137-967afa7f5ced",
        q12: "27e4eb19-676d-4347-a346-94a9f3330fca",
        q13: "d559c1da-76c4-4aa7-8331-d4e149d42ec0",
        q14: "64dbd1da-a8a9-40a6-9da9-c3c722a63153",
        q15: "6f4758ee-e699-4cd6-be86-ec2896d99713",
        q16: "85942cb6-0766-41e4-8b21-42f238387cf9",
        q17: "e8e9648d-216e-45ac-8db2-21630cdf7b5e",
        q18: "fd385738-e67e-41ab-975c-e4d1a1a0f0d1",
        q19: "6f1f7aeb-83da-4a6e-ae91-3e1fee4b974f",
        q20: "d44bb4f1-a479-4c15-8b90-c039b1e7080a",
        q21: "806801ad-3e84-4729-a858-1363ce76aa86",
        q22: "e8bc4613-447f-4b9b-8f2d-782df418c56d",
        q23: "43f658e1-2cc8-4491-b3f3-407e0a0dea1f",
        q24: "c91be135-1996-400f-8c86-c8a4b955a6d1",
        q25: "1dd78fe6-bb3c-4762-9353-5495140886de",
        q26: "acf263de-69d8-4678-ab4f-927260c9b5d3",
        q27: "916e9708-86b6-47f7-b81f-4ea792f60058",
        q28: "7b58df36-63fb-4dbd-bf15-82fcb5ff7761",
        q29: "631c7eea-ad0b-42d9-9061-6314c77c4100",
    },
    msis29Inputs: {
        // MSIS-29 Calculated Scores (0-100)
        physicalScore: "f59672da-2b67-4e10-bc20-6b5dca1a94d7",
        psychologicalScore: "823bc635-608b-44aa-a732-cfa6a5480e8f",
    },
    symptomNrsInputs: {
        spasticity: "102bb7f8-6c57-4f7e-b28d-bda5f89d1bcd",
        pain: "bc130cf8-106c-48c7-83da-94760b04e0cf",
        sleepProblems: "e27321e5-54e7-42bf-b71a-9975bba04f57",
        fatigue: "7a8791f8-3986-48e8-afbc-c027bf37e508",
    },
    phq9Inputs: {
        // PHQ-9 Total Score
        totalScore: "c1dd14ea-d118-4bb4-803a-a6f8bd464855",
    },
    rolandMorrisInputs: {
        totalScore: "99ab18e0-0a46-465a-9b6f-c73802294471",
    },
    gad7Inputs: {
        // GAD-7 Total Score
        totalScore: "53121eb7-3ffd-44ab-9168-79b28be84d66",
    },
    avvqInputs: {
        totalScore: "987dcf36-e522-4c54-ba35-585d7630322e",
    },
    pdqInputs: {
        // PDQ Subscale Scores
        problemsDuringVaginalIntercourse: "f4a5b6c7-d8e9-4012-f345-6789abcdef01",
        painAndDiscomfort: "a5b6c7d8-e9f0-4123-a456-789abcdef012",
        symptomBother: "b6c7d8e9-f0a1-4234-b567-89abcdef0123",
        totalScore: "c7d8e9f0-a1b2-4345-c678-9abcdef01234",
    },
    iief6Inputs: {
        // IIEF-6 Total Score
        totalScore: "247204fe-c552-4f7c-9078-f3ad347d2240",
        // IIEF-6 Question Inputs
        q1: "0f897d5a-d4b9-4e2c-aa9b-66e620d544b4",
        q2: "a78ce452-c709-4a3b-ae77-3b94c7929f77",
        q3: "13dce911-bc70-4dc5-a5fd-96c3ea5328b2",
        q4: "2ea7ec9f-f071-4920-bab7-de1ed21903b6",
        q5: "4c57e8d3-94a1-4fd5-a89a-679aa631816e",
        // Question 6 on the short form. Item 15 of the full IIEF (erection confidence).
        q6: "87806703-9d94-43f1-85ae-33dabddff0d7",
    },
    sqolMInputs: {
        // SQoL-M Total Score
        totalScore: "bbef84ca-f9fc-4b78-b1dd-3f60bb06b00b",
        // SQoL-M Question Inputs
        q1: "c9d31be6-7e21-4ff8-9c53-6a7bfde7ca1f",
        q2: "4a0b4d30-0c60-4884-94b0-49bc01b7902b",
        q3: "5451331e-737c-4da9-a4e0-5b17e4a50271",
        q4: "8efe42f1-05c1-46fa-bf85-a648306248f4",
        q5: "60114f85-504d-468d-a2de-51fd848f8418",
        q6: "f713e081-5723-4b12-a95d-9a2e2b86f341",
        q7: "b1c49315-668a-46ab-81a0-b647f421864e",
        q8: "f6092fe8-af03-4abb-b930-2c16bf866439",
        q9: "d87fedf6-79f3-4f2c-b064-0cb1faea5b5f",
        q10: "ed2a461c-4c7f-4011-b332-e5151f9b6fca",
        q11: "1ce64f24-3721-4d73-bedc-0867043bf01e",
    },
    pgiIInputs: {
        // PGI-I Score (calculated)
        score: "9bb50f53-2a27-408c-8fd1-d39f0148f2b7",
        // PGI-I Question Input
        question: "40bfe216-9c1b-4831-a912-df1e4119efd4",
    },
    kellgrenLawrenceInputs: {
        grade: "864da7a8-47f0-4ac8-a33f-13fe9f02206f",
    },
    overallTreatmentSatisfactionInputs: {
        satisfaction: "c6a3c187-c1c3-48c1-8fb4-63bee0f289b1",
        comments: "c73cfb6a-efa9-4dfd-a458-4b09edc576a0",
        score: "a21e3ec4-ba8c-41cf-9c34-896bf337958a",
    },
    furtherTreatmentSinceCheckinPages: {
        followUp: "2ddb724b-f765-4618-900a-34c9c2d2e4ff",
    },
    furtherTreatmentSinceCheckinInputs: {
        furtherTreatmentYesNo: "9a28826c-19b5-465d-9e2a-85efb3a8ab86",
        chartScore: "4d30f1fc-804f-485a-9168-cfd5ed29b79b",
    },
    bctqPages: {
        symptomSeverity: "542212a2-7e49-4bae-846f-489dccd0f36e",
        functionalStatus: "6dab7575-8cf3-4262-8f8e-37be2cb3b36d",
    },
    bctqInputs: {
        // BCTQ Calculated Scores
        symptomSeverityScore: "5e2882ac-6838-4bff-bd46-dc0cfdf412bb",
        functionalStatusScore: "ff0c1153-7af5-45b1-9a69-8f2dfb3630d8",
    },
    ihot12Inputs: {
        // iHOT-12 Total Score (calculated - mean of all 12 items)
        totalScore: "6d6a491d-5237-42c2-89bd-334604493d01",
        // iHOT-12 Question Inputs (Q1-Q12)
        q1: "755d2b58-3c63-4c48-96e7-46b68cece26e", // Hip/groin pain
        q2: "e0c67f6a-3e1b-495e-9363-fc39390e8660", // Getting up from floor
        q3: "f55ed448-4169-4ed1-b6fc-f33c738a14e2", // Walking long distances
        q4: "969f3e2a-8a36-4048-a2b3-71f24fd5b346", // Grinding/catching/clicking
        q5: "510e3c14-8af1-403d-ad82-4ccafbd6a156", // Pushing/pulling/lifting
        q6: "a11689b1-7f0e-4ca7-a283-c561a45af7b3", // Carrying children
        q7: "9248fff4-53d3-4eaa-b5c0-6cd66531dd05", // Cutting/changing directions
        q8: "f6282c48-8817-4a55-90c0-50cfbcb84d0d", // Sexual activity
        q9: "bb039de8-ecce-4a02-bef8-0e6664983576", // Awareness of disability
        q10: "ae46a9f6-e937-4470-9976-b081937d0ee6", // Maintaining fitness
        q11: "2c30fb19-fae3-4aa3-954a-64dd4239af3d", // Pain after activity
        q12: "bf70392b-8618-41ad-a426-4e837e882bb9", // Hip distraction
    },
    kujalaInputs: {
        totalScore: "52fa898a-d629-4402-ae2d-c2087667561b",
    },
    ikdcInputs: {
        totalScore: "7e1ec47b-8d86-45b6-9fcb-86b05cdae06e",
    },
    visaASedentaryInputs: {
        totalScore: "00a8dd23-63bd-4cee-bfac-2e3e4a55a287",
        symptomsScore: "994cc162-4943-4528-be50-201a24b979de",
        activityScore: "f8ffa59a-4f26-40b0-b036-c80268eb686a",
    },
    fasInputs: {
        totalScore: "3a8c456d-9c93-4569-97f4-6b178d054b9e",
        physicalFatigueScore: "08bb5f2c-548f-41ea-836e-e890f666de0c",
        mentalFatigueScore: "8c13e7c2-08b6-43e0-8275-08fc9a07d081",
    },
    aofasPages: {
        pain: "66b2d1cf-c5d2-407e-a90a-998836cb51b4",
        function: "b35bc132-59a9-4124-b32b-8904fc261768",
        alignment: "c8dcc925-c180-44d1-8752-45df5dd7cd74",
    },
    aofasInputs: {
        // AOFAS Calculated Scores
        painScore: "ecd2b6f5-39f0-465e-b51c-7df146202265",
        functionScore: "6e67d15f-cfe4-4942-98f1-0ae02363bb46",
        alignmentScore: "ba3745c2-f103-4556-b133-29e0020d4644",
        totalScore: "95ad2228-bf5f-418b-9cfd-1f94e02737d0",
        // AOFAS Question Inputs
        pain: "c6674c76-6e4c-4a4d-b82a-caa1a51b8aba", // Pain level
        activityLimitations: "93d4b5f0-2947-4ef1-8bee-6eb5973165bf",
        walkingDistance: "b115f7f0-c759-40da-b8da-6e9e4043c6f2",
        walkingSurfaces: "a6d80701-5e2c-4d17-a651-ab9d22a19d0a",
        gaitAbnormality: "fd849216-60cc-4751-bc50-fd9e4bb90c3d",
        sagittalMotion: "f1387555-7a02-4d63-9766-467210c1f415",
        hindfootMotion: "04ae7ebb-5a7a-4201-b641-d237c13e5b7d",
        ankleStability: "bc3118aa-d794-4c1b-a134-6e0e2ab701d9",
        alignment: "afed0730-405a-4b36-8828-deb359ce9e55",
    },
} as const;

// Type for the UUIDs object
export type UUIDs = typeof UUIDs;

// Helper type to get all possible UUID values
export type UUIDValue = UUIDs[keyof UUIDs][keyof UUIDs[keyof UUIDs]];

// Helper function to check if a string is a valid UUID from our table
export function isValidUUID(uuid: string): uuid is UUIDValue {
    return Object.values(UUIDs).some((category) => Object.values(category).includes(uuid as UUIDValue));
}

// Helper function to get the category and name of a UUID
export function getUUIDInfo(uuid: string): { category: string; name: string } | null {
    for (const [category, values] of Object.entries(UUIDs)) {
        for (const [name, value] of Object.entries(values)) {
            if (value === uuid) {
                return { category, name };
            }
        }
    }
    return null;
}
